module.exports = __webpack_public_path__ + "media/images/michelle-54e1698f2979d770fb9a3e9993c9e528.png";